import { SVGProps, Ref, forwardRef } from 'react';

export const AppleBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M20.34 8.5c-.128.1-2.38 1.37-2.38 4.192 0 3.265 2.866 4.42 2.952 4.449-.013.07-.456 1.582-1.512 3.122-.941 1.355-1.925 2.708-3.42 2.708-1.497 0-1.882-.869-3.61-.869-1.682 0-2.28.898-3.65.898-1.368 0-2.323-1.254-3.42-2.794C4.027 18.397 3 15.588 3 12.92c0-4.277 2.781-6.546 5.518-6.546 1.454 0 2.667.955 3.58.955.869 0 2.224-1.012 3.879-1.012.627 0 2.88.057 4.363 2.183"
                fill="currentColor"
            />
            <path
                d="M15.191 4.507c.685-.812 1.169-1.938 1.169-3.065 0-.156-.014-.314-.042-.442-1.113.042-2.438.741-3.237 1.668-.627.713-1.212 1.84-1.212 2.981 0 .172.029.343.042.398.07.014.185.029.3.029.998 0 2.254-.669 2.98-1.569"
                fill="currentColor"
            />
        </g>
    </svg>
));
AppleBrandSize24Glyph.displayName = 'AppleBrandSize24Glyph';
